module.exports = __webpack_public_path__ + "img/建筑装修装饰工程专业承包一级.a5ea6e88.jpg";